'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../hooks';
import { OneTrustLegacy } from './legacy';
export function OneTrustScripts(t0) {
  const $ = _c(2);
  const {
    customerKey
  } = t0;
  const isOneTrust = useDecisions("onetrust");
  if (isOneTrust) {
    return null;
  }
  let t1;
  if ($[0] !== customerKey) {
    t1 = <OneTrustLegacy customerKey={customerKey} />;
    $[0] = customerKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}